<template>
  <div id="app">
    <error-boundary><router-view /></error-boundary>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import './assets/css/reset.css';
</style>
<style lang="less" scoped>
  html,
  body {
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #app {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f8f8f8;
    overflow-y: auto;
    // -webkit-overflow-scrolling: touch;
  }
</style>
